// extracted by mini-css-extract-plugin
export default {"root":"MainContent_root__E1hj3","root_wrapper":"MainContent_root_wrapper__wrxNh"};